import { render, staticRenderFns } from "./u-select-solo-pill.vue?vue&type=template&id=f96e0eb4&scoped=true&"
import script from "./u-select-solo-pill.vue?vue&type=script&lang=js&"
export * from "./u-select-solo-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96e0eb4",
  null
  
)

export default component.exports